// Track page views

import type { StoryType } from '~/types/story'

// Keep track of stories, topics and audiences viewed
export const useViewTracking = () => {
  const { viewStory } = useViewedStoriesStore()
  const { viewTopics } = useViewedTopicsStore()
  const { viewAudiences } = useViewedAudiencesStore()

  // Track story view
  const trackView = (story: MaybeRef<StoryType>) => {
    const storyData = unref(story)
    viewStory(storyData)
    viewTopics(storyData?.content?.topics)
    viewAudiences(storyData?.content?.audiences)
  }

  return { trackView }
}
